import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ArrowUpCircle, Droplets, ListChecks, BrainCircuit } from 'lucide-react';
export function StabilizationLadder() {
  const steps = [{
    icon: <ArrowUpCircle className="h-8 w-8 text-white" data-id="element-372" />,
    title: 'Step 1: Mask-Fit Triage',
    desc: 'Not "tighten it." A quick process to stabilize seal in the position you actually sleep.'
  }, {
    icon: <Droplets className="h-8 w-8 text-white" data-id="element-373" />,
    title: 'Step 2: The Leak → Dry‑Mouth Map',
    desc: "Dry mouth isn't one problem. You'll identify which kind you have and what it usually means—so you stop guessing."
  }, {
    icon: <ListChecks className="h-8 w-8 text-white" data-id="element-374" />,
    title: 'Step 3: Settings Questions Checklist',
    subtitle: '(so you stop getting dismissed)',
    desc: "You'll get the exact language to bring to your clinic/provider so you get real help—without sounding like you're trying to be your own doctor."
  }, {
    icon: <BrainCircuit className="h-8 w-8 text-white" data-id="element-375" />,
    title: 'Step 4: The "Rip‑It‑Off" Retraining Plan',
    desc: 'Because for many men, the real issue isn\'t the mask. It\'s the moment your nervous system decides, "Nope." This plan helps you reduce removals without turning bedtime into a fight.'
  }];
  return <section className="py-14 px-4 bg-white relative overflow-hidden" data-id="element-376">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full bg-blue-50 opacity-50 -z-10" data-id="element-377" />

      <div className="max-w-4xl mx-auto" data-id="element-378">
        <FadeIn data-id="element-379">
          <div className="text-center mb-10" data-id="element-380">
            <span className="text-teal-600 font-bold tracking-wider uppercase text-sm mb-2 block" data-id="element-381">
              The Solution
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-navy-800 mb-6" data-id="element-382">
              The 30‑Night Stabilization Ladder
            </h2>
            <p className="text-xl text-text-body max-w-2xl mx-auto" data-id="element-383">
              This guide gives you a stepwise system that turns chaos into a
              repeatable routine:
            </p>
          </div>
        </FadeIn>

        <div className="space-y-8 relative" data-id="element-384">
          {/* Connecting line */}
          <div className="absolute left-8 top-8 bottom-8 w-1 bg-gray-200 hidden md:block" data-id="element-385" />

          {steps.map((step, index) => <FadeIn key={index} delay={index * 150} data-id="element-386">
              <div className="relative flex flex-col md:flex-row gap-6 bg-white p-8 rounded-xl shadow-sm border border-gray-100 z-10" data-id="element-387">
                <div className="flex-shrink-0" data-id="element-388">
                  <div className="w-16 h-16 rounded-full bg-navy-800 flex items-center justify-center shadow-lg" data-id="element-389">
                    {step.icon}
                  </div>
                </div>
                <div data-id="element-390">
                  <h3 className="text-xl md:text-2xl font-bold text-navy-800 mb-2" data-id="element-391">
                    {step.title}{' '}
                    {step.subtitle && <span className="text-gray-500 font-normal text-lg block md:inline" data-id="element-392">
                        {step.subtitle}
                      </span>}
                  </h3>
                  <p className="text-lg-body text-text-body leading-relaxed" data-id="element-393">
                    {step.desc}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}